<template>
    <el-dialog class="dialog" :visible="dialogs.standards" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Создать или найти ПС</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form" @submit.prevent>
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="createEntity">
                        <h3>Заполните новый ПС</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedEntity" />
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item">
                                    <button type="submit" :disabled="!name" class="btn btn_action">Создать</button>
                                </div>
                            </div>
                        </form>                      
                    </div>
                </transition>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    max-height="400"
                    ref="table"
                    row-key="id"
                    :data="tableData"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                    @selection-change="handleSelectionChange"
                    @sort-change="sortChange"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <el-radio :label="scope.row" v-model="activeStandard"></el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <el-pagination
                    background
                    class="mt-24"
                    layout="prev, pager, next"
                    :current-page="page"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="setPage"
                >
                </el-pagination>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" :disabled="createEntity" @click="createEntity = true">
                            Создать новый ПС

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="!activeStandard" @click="submitSelected">Добавить выбранный ПС</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MaskedInput from 'vue-masked-input';

import constants from '@/constants.js';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

export default {
    mixins: [ dialog ],
    components: {
        MaskedInput,
        ValidateInput
    },
    props: {
        kindId: Number,
        standardId: Number
    },
    data() {
        return {
            checkedEntity: true,
            activeStandard: null,
            name: '',
            nameError: false,
        }
    },
    methods: {
        ...mapActions('editor', ['LOAD_KINDS', 'LOAD_STANDARD', 'LOAD_OKZS', 'LOAD_OKVEDS', 'LOAD_WORK_FUNCTIONS_BY_STANDARD', 'CREATE_STANDARD', 'UPDATE_STANDARD']),
        ...mapActions('listsForEditor', ['LOAD_STANDARDS']),
        ...mapMutations('editor', ['SET_SELECTED_AREAS']),
        ...mapMutations('listsForEditor', ['ADD_STANDARDS']),

        closeDialog() {
            this.input = ''
            this.name = ''
            this.createEntity = false;
            this.nameError = false

            this.elDialogs.standards = false;
        },
        async createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                kind_id: null,
                onlyCreate: true,
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            const tempStandart = await this.CREATE_STANDARD(params);
            this.ADD_STANDARDS(tempStandart)
            this.data.push(tempStandart)

            if (this.checkedEntity) {
                this.activeStandard = this.data.find((item) => item.id === tempStandart.id) || null;
            }

            e.target.reset();
        },
        async handleOpen() {
            await this.loadStandards();

            this.activeStandard = this.data.find((item) => item.id === this.standardId) || null;
        },
        async loadStandards() {
            if (this.standards.length === 0) await this.LOAD_STANDARDS();

            this.data = [...this.standards];
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            this.$emit('startLoad')
            await this.LOAD_STANDARD(this.activeStandard.id);
            await this.UPDATE_STANDARD({
                ...this.standard,
                kind_id: this.kindId
            });

            await this.LOAD_OKZS(),
            await this.LOAD_OKVEDS(),
            await this.LOAD_WORK_FUNCTIONS_BY_STANDARD(this.activeStandard.id)
            await this.LOAD_KINDS()
            this.$emit('finishLoad')

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['standard']),
        ...mapState('listsForEditor', ['standards']),
        
        filtered() {
            // Фильтруем по поиску
            return !this.searchValue ? this.data : this.data.filter((item) => String(item.code).toLowerCase().includes(this.searchValue.toLowerCase()) || item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        tableData() {
            // Пагинация
            return this.filtered.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
